<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.5 18.75V13.2812M12.5 13.2812C13.0395 13.2812 13.5631 13.2129 14.0625 13.0844M12.5 13.2812C11.9605 13.2812 11.4369 13.2129 10.9375 13.0844M14.8438 20.8744C14.0846 21.0184 13.3011 21.0938 12.5 21.0938C11.6989 21.0938 10.9154 21.0184 10.1562 20.8744M14.0625 23.3562C13.549 23.41 13.0277 23.4375 12.5 23.4375C11.9723 23.4375 11.451 23.41 10.9375 23.3562M14.8438 18.75V18.5503C14.8438 17.5265 15.5294 16.6511 16.4151 16.1372C18.7454 14.7852 20.3125 12.2631 20.3125 9.375C20.3125 5.06028 16.8147 1.5625 12.5 1.5625C8.18528 1.5625 4.6875 5.06028 4.6875 9.375C4.6875 12.2631 6.25464 14.7852 8.58495 16.1372C9.47055 16.6511 10.1563 17.5265 10.1563 18.5503V18.75"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgIdea',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
